import { Outlet, NavLink, Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/AuthContext";
import { Home, Bell, Briefcase, FileText, User, LogOut } from "lucide-react";
import { NetstaffLogo } from "@/components/NetstaffLogo";

const tabs = [
  { to: "/pro", icon: Home, label: "Home", end: true },
  { to: "/pro/offers", icon: Bell, label: "Offers" },
  { to: "/pro/shifts", icon: Briefcase, label: "Shifts" },
  { to: "/pro/timesheets", icon: FileText, label: "Time" },
  { to: "/pro/profile", icon: User, label: "Profile" },
];

export default function ProfessionalLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-slate-50 pb-24">
      <header className="glass-nav sticky top-0 z-40 border-b border-slate-200">
        <div className="max-w-md mx-auto px-4 py-3 flex items-center justify-between">
          <Link to="/pro"><NetstaffLogo className="h-8 w-8" textClass="text-base" /></Link>
          <button onClick={() => { logout(); navigate("/"); }} data-testid="pro-logout-btn">
            <LogOut className="w-5 h-5 text-slate-500" />
          </button>
        </div>
      </header>
      <main className="max-w-md mx-auto px-4 py-6">
        <Outlet />
      </main>
      <nav className="fixed bottom-0 left-0 right-0 bg-white border-t border-slate-200 z-40">
        <div className="max-w-md mx-auto grid grid-cols-5 px-2">
          {tabs.map((t) => {
            const Icon = t.icon;
            return (
              <NavLink
                key={t.to}
                to={t.to}
                end={t.end}
                data-testid={`pro-tab-${t.label.toLowerCase()}`}
                className={({ isActive }) =>
                  `flex flex-col items-center justify-center py-3 text-[10px] uppercase tracking-wider font-semibold transition-colors ${
                    isActive ? "text-brand-teal" : "text-slate-500 hover:text-slate-700"
                  }`
                }
              >
                <Icon className="w-5 h-5 mb-1" />
                {t.label}
              </NavLink>
            );
          })}
        </div>
      </nav>
    </div>
  );
}
